import React from 'react';
import { useTranslate } from '../../../../context/api-context/translations/use-translate';
import { useApi } from '../../../../context/api-context/use-api';
import { getIsRtl, getIsMobile, } from '../../../../../common/store/base-params/base-params-selectors';
import { getMemberCache, getReactionOwner, } from '../../../../../common/store/members/members-selectors';
import { useConfiguration } from '../../../../context/configuration-context/use-configuration';
import { MemberList } from '../member-list/member-list';
import { classes, st } from './emotions-list-modal.st.css';
import { EmotionListModalComponent as EmotionListModalComponentBase } from '../../../../../reactions';
const EmotionListModal = (props) => {
    const { memberCache, isRtl, isMobile } = useApi((state) => ({
        memberCache: getMemberCache(state),
        isRtl: getIsRtl(state),
        isMobile: getIsMobile(state),
    }));
    const { hideAvatars } = useConfiguration();
    const t = useTranslate();
    const resolveMembersList = (reactedMembers) => {
        return reactedMembers.map((member) => ({
            ...getReactionOwner(memberCache, member.id),
            reactionCode: member.reactionCode,
        }));
    };
    return (React.createElement(EmotionListModalComponentBase, { ...props, t: t, isRtl: isRtl, isMobile: isMobile }, ({ membersToRender, mainReactionName, showReaction }) => (React.createElement(MemberList, { className: st(classes.memberList, { isMobile }), memberList: resolveMembersList(membersToRender), showReaction: showReaction, mainReactionName: mainReactionName, showAvatars: !hideAvatars }))));
};
export default EmotionListModal;
//# sourceMappingURL=emotions-list-modal.js.map